/* eslint-disable */
export default {
  start: 'Nehmen Sie an einer kurzen Einführung teil',
  skip: 'Überspringen',
  next: 'Weiter',
  finish: 'Fertig stellen',
} as const;

// @key: @#@"start"@#@ @source: @#@"Take a quick tour"@#@
// @key: @#@"skip"@#@ @source: @#@"Skip"@#@
// @key: @#@"next"@#@ @source: @#@"Next"@#@
// @key: @#@"finish"@#@ @source: @#@"Finish"@#@
